var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',[_c('b-col',[_c('b-tabs',[_c('b-tab',{attrs:{"title":"Podsumowanie"}},[_c('b-card',[_c('h6',[_vm._v("Dane statystyczne")]),_c('b-table',{attrs:{"items":_vm.items,"fields":_vm.fields}})],1)],1),_c('b-tab',{attrs:{"title":"Pełen raport"}}),_c('b-tab',{attrs:{"title":"Błędy"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }